import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Valeria G.',
  location: 'Gran Buenos Aires',
  role: 'Mamá de Matías, 7 años',
  quote: <>
        Después de aplicar la rutina antiansiedad, mi hijo pasó de tener crisis{' '}
        <span className="inline-block rounded-full bg-[#EDE9FF] px-2 py-0.5 font-bold text-[#6B21A8]" data-id="element-317">
          TODAS las mañanas
        </span>{' '}
        a entrar solo al colegio. La diferencia fue inmediata.
      </>
}, {
  name: 'Romina T.',
  location: 'Córdoba',
  role: 'Mamá de Sofía, 6 años',
  quote: <>
        La primera semana implementé la rutina nocturna. La segunda semana mi
        hijo durmió solo por primera vez en{' '}
        <span className="inline-block rounded-full bg-[#EDE9FF] px-2 py-0.5 font-bold text-[#6B21A8]" data-id="element-318">
          DOS AÑOS
        </span>
        . Lloré de alivio.
      </>
}, {
  name: 'Karina M.',
  location: 'Rosario',
  role: 'Mamá de Tomás, 9 años',
  quote: <>
        El Protocolo de Emergencia lo imprimí y pegué en la pared. La última
        crisis{' '}
        <span className="inline-block rounded-full bg-[#EDE9FF] px-2 py-0.5 font-bold text-[#6B21A8]" data-id="element-319">
          supe exactamente qué hacer
        </span>
        . No entré en pánico.
      </>
}];
export const Testimonials = () => {
  return <section className="relative w-full overflow-hidden bg-[#F8F6FF] py-12 sm:py-16 md:py-20" data-id="element-320">
      <div className="absolute left-0 right-0 top-0 h-px bg-gradient-to-r from-transparent via-[#A855F7]/30 to-transparent" data-id="element-321" />

      <div className="mx-auto max-w-[720px] px-5" data-id="element-322">
        <div className="mb-12 text-center" data-id="element-323">
          <span className="mb-4 inline-block rounded-full bg-[#6B21A8] px-3 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-324">
            RESULTADOS REALES
          </span>
          <h2 className="font-heading text-3xl font-bold text-[#1A0A2E] sm:text-4xl md:text-5xl" data-id="element-325">
            Lo que dicen las mamás
            <br data-id="element-326" />
            <span className="text-violet-gradient" data-id="element-327">que ya lo tienen.</span>
          </h2>
        </div>

        <div className="flex flex-col gap-6" data-id="element-328">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} whileHover={{
          y: -4
        }} className="relative rounded-[20px] border border-[#7C3AED]/10 bg-white p-7 shadow-card-light transition-shadow hover:shadow-card-hover" data-id="element-329">
              <div className="absolute left-0 top-6 h-12 w-[3px] rounded-r-full bg-[#6B21A8]" data-id="element-330" />

              <div className="mb-5 flex items-center gap-4 pl-2" data-id="element-331">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-violet-gradient text-lg font-bold text-white shadow-inner" data-id="element-332">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-333">
                  <h3 className="font-bold text-[#1A0A2E]" data-id="element-334">{t.name}</h3>
                  <p className="text-xs text-[#9B8EC4]" data-id="element-335">{t.location}</p>
                  <div className="mt-1 flex gap-0.5" data-id="element-336">
                    {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-[#D4A017] text-[#D4A017]" data-id="element-337" />)}
                  </div>
                </div>
              </div>

              <div className="relative pl-2" data-id="element-338">
                <span className="absolute -left-2 -top-2 font-heading text-4xl font-black text-[#EDE9FF]" data-id="element-339">
                  "
                </span>
                <p className="relative z-10 mb-5 text-base italic leading-relaxed text-[#1A0A2E]" data-id="element-340">
                  {t.quote}
                </p>
                <span className="inline-block rounded-full bg-[#EDE9FF] px-3 py-1 text-xs font-semibold text-[#6B21A8]" data-id="element-341">
                  {t.role}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};